module.exports = __webpack_public_path__ + "static/javelin_of_lightning-27b8d41c3e1bea6e8a179df71d3d821a.jpeg";